featuredPropertiesCarousel();
teamCarousel();
imageCarousel();

function featuredPropertiesCarousel(){
  jQuery('.js-fp-carousel').each(function(){
    jQuery(this).owlCarousel({
      items: 1,
      loop:true,
      nav: true,
      dots: false,
      smartSpeed:450,
    });
  });
}

function teamCarousel(){
  jQuery('.js-team-carousel').each(function(){
    jQuery(this).owlCarousel({
      items: 4,
      loop:true,
      nav: true,
      dots: false,
      margin: 15,
      responsive : {
        0 : {
            items: 1
        },
        480 : {
            items: 2,
        },
        768 : {
            items: 3,
        },
        1024 : {
            items: 4,
        }
    }
    });
  });
}

function imageCarousel(){
  jQuery('.js-image-carousel').each(function(){
    jQuery(this).owlCarousel({
      items: 2,
      nav: true,
      dots: false,
      responsive : {
        0 : {
            items: 1
        },
        768 : {
            items: 2,
        },
    }
    });
  });
}